import styled from 'styled-components';
import Link from '../Link';
export default styled(Link)`
  position: absolute;
  top: 0;
  left: 0;

  background-color: ${({
  theme
}) => theme.palette.actionableHover};
  color: ${({
  theme
}) => theme.palette.contentReverse};
  padding: 1rem;

  &:focus,
  &:hover {
    color: ${({
  theme
}) => theme.palette.contentReverse};
  }

  z-index: ${props => props.theme.zIndex.dropdown};
`;
//# sourceMappingURL=styles.js.map